(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rdb-collection-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
    const revealCurrentCollection = (scope = document) => {
      scope.querySelectorAll('[data-collection-navigation]').forEach((nav) => {
        const current = nav.querySelector('[aria-current="page"]');
        if (!current) return;
        requestAnimationFrame(() => {
          const strip = nav.getBoundingClientRect();
          const tab = current.getBoundingClientRect();
          if (tab.right > strip.right - 16) nav.scrollLeft += tab.right - strip.right + 16;
          else if (tab.left < strip.left + 16) nav.scrollLeft -= strip.left + 16 - tab.left;
        });
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => revealCurrentCollection(), { once: true });
    } else {
      revealCurrentCollection();
    }
    document.fonts.ready.then(() => revealCurrentCollection());
    document.addEventListener('rdb:catalog-render', (event) => revealCurrentCollection(event.target));
    document.addEventListener('shopify:section:load', (event) => revealCurrentCollection(event.target));
    window.addEventListener('resize', () => revealCurrentCollection(), { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
